import { lighten } from 'polished';
import styled from 'styled-components';
import { darkenColorUntilHasContrastEnough } from './seller-chip.utils';

const ChipHeight = '2rem';

export const SellerChipContainer = styled.div<{ $color: string }>`
  background-color: ${(p) => lighten(0.15, p.$color)};
  color: ${(p) => darkenColorUntilHasContrastEnough(p.$color, p.$color)};
  border: 1px solid ${(p) => lighten(0.05, p.$color)};
  font-size: 1.3rem;
  margin: 0;
  padding: 0.2rem 0.9rem;
  border-radius: 0.5rem;
  height: ${ChipHeight};
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: break-spaces;
  height: fit-content;
`;
